"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.richTextReducer = exports.updateTextStyleBulletList = exports.updateTextStyleNumberList = exports.updateTextStyleFontSize = exports.updateTextStyleColor = exports.updateTextStyleUnderline = exports.updateTextStyleItalic = exports.updateTextStyleBold = exports.updateTextStyles = exports.setTextStyle = exports.TextStyle = exports.RichTextStateActionType = void 0;
const react_1 = require("react");
const text_1 = require("../utils/text");
var RichTextStateActionType;
(function (RichTextStateActionType) {
    RichTextStateActionType["UpdateTextStyleAll"] = "updateTextStyleAll";
    RichTextStateActionType["UpdateTextStyleBold"] = "updateTextStyleBold";
    RichTextStateActionType["UpdateTextStyleItalic"] = "updateTextStyleItalic";
    RichTextStateActionType["UpdateTextStyleUnderline"] = "updateTextStyleUnderline";
    RichTextStateActionType["UpdateTextStyleColor"] = "updateTextStyleColor";
    RichTextStateActionType["UpdateTextStyleFontSize"] = "updateTextStyleFontSize";
    RichTextStateActionType["UpdateTextStyleNumberList"] = "updateTextStyleNumberList";
    RichTextStateActionType["UpdateTextStyleBulletList"] = "updateTextStyleBulletList";
})(RichTextStateActionType || (exports.RichTextStateActionType = RichTextStateActionType = {}));
var TextStyle;
(function (TextStyle) {
    TextStyle["Bold"] = "bold";
    TextStyle["Italic"] = "italic";
    TextStyle["Underline"] = "underline";
    TextStyle["NumberList"] = "insertOrderedList";
    TextStyle["BulletList"] = "insertUnorderedList";
    TextStyle["ForeColor"] = "foreColor";
    TextStyle["FontSize"] = "fontSize";
})(TextStyle || (exports.TextStyle = TextStyle = {}));
function setTextStyle(style, value) {
    if (value) {
        document.execCommand(style, false, value);
    }
    else {
        document.execCommand(style);
    }
}
exports.setTextStyle = setTextStyle;
const updateTextStyles = () => ({
    type: RichTextStateActionType.UpdateTextStyleAll,
});
exports.updateTextStyles = updateTextStyles;
const updateTextStyleBold = (isBold) => ({
    type: RichTextStateActionType.UpdateTextStyleBold,
    payload: isBold,
});
exports.updateTextStyleBold = updateTextStyleBold;
const updateTextStyleItalic = (isItalic) => ({
    type: RichTextStateActionType.UpdateTextStyleItalic,
    payload: isItalic,
});
exports.updateTextStyleItalic = updateTextStyleItalic;
const updateTextStyleUnderline = (isUnderline) => ({
    type: RichTextStateActionType.UpdateTextStyleUnderline,
    payload: isUnderline,
});
exports.updateTextStyleUnderline = updateTextStyleUnderline;
const updateTextStyleColor = (color) => ({
    type: RichTextStateActionType.UpdateTextStyleColor,
    payload: color,
});
exports.updateTextStyleColor = updateTextStyleColor;
const updateTextStyleFontSize = (size) => ({
    type: RichTextStateActionType.UpdateTextStyleFontSize,
    payload: size,
});
exports.updateTextStyleFontSize = updateTextStyleFontSize;
const updateTextStyleNumberList = (isNumberList) => ({
    type: RichTextStateActionType.UpdateTextStyleNumberList,
    payload: isNumberList,
});
exports.updateTextStyleNumberList = updateTextStyleNumberList;
const updateTextStyleBulletList = (isBulletList) => ({
    type: RichTextStateActionType.UpdateTextStyleBulletList,
    payload: isBulletList,
});
exports.updateTextStyleBulletList = updateTextStyleBulletList;
function richTextReducer(state, action) {
    switch (action.type) {
        case RichTextStateActionType.UpdateTextStyleBold:
            return Object.assign(Object.assign({}, state), { isBold: action.payload });
        case RichTextStateActionType.UpdateTextStyleItalic:
            return Object.assign(Object.assign({}, state), { isItalic: action.payload });
        case RichTextStateActionType.UpdateTextStyleUnderline:
            return Object.assign(Object.assign({}, state), { isUnderline: action.payload });
        case RichTextStateActionType.UpdateTextStyleColor:
            return Object.assign(Object.assign({}, state), { foreColor: action.payload });
        case RichTextStateActionType.UpdateTextStyleFontSize:
            return Object.assign(Object.assign({}, state), { fontSize: action.payload });
        case RichTextStateActionType.UpdateTextStyleNumberList:
            return Object.assign(Object.assign({}, state), { isNumberList: action.payload });
        case RichTextStateActionType.UpdateTextStyleBulletList:
            return Object.assign(Object.assign({}, state), { isBulletList: action.payload });
        case RichTextStateActionType.UpdateTextStyleAll:
            const isBold = document.queryCommandState(TextStyle.Bold);
            const isItalic = document.queryCommandState(TextStyle.Italic);
            const isUnderline = document.queryCommandState(TextStyle.Underline);
            const fontSize = document.queryCommandValue(TextStyle.FontSize);
            const isNumberList = document.queryCommandState(TextStyle.NumberList);
            const isBulletList = document.queryCommandState(TextStyle.BulletList);
            let foreColor = document.queryCommandValue(TextStyle.ForeColor);
            if (foreColor) {
                foreColor = (0, text_1.replaceAll)(foreColor, ' ', '');
            }
            return Object.assign(Object.assign({}, state), { isBold: isBold, isItalic: isItalic, isUnderline: isUnderline, foreColor: foreColor, fontSize: fontSize, isNumberList: isNumberList, isBulletList: isBulletList });
        default:
            return state;
    }
}
exports.richTextReducer = richTextReducer;
function useRichTextReducer(state) {
    return (0, react_1.useReducer)(richTextReducer, state);
}
exports.default = useRichTextReducer;
